import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Input from "../../components/reusable-input/Input";
import Button from "../../components/reusable-button/Button";
import logo from "../../asstets/images/vcu_logo.png";
import { login } from "../../apis/authApis";
import { EyeOffIcon, EyeOpenIcon } from "../../icons/reactIcons";
import { fetchAdminPermissions } from "../../redux/slices/permissionsSlice";
import { useAppDispatch } from "../../redux/store/hooks";
import { toast } from "react-toastify";
import { isEmpty, isValidEmail } from "../../utils/validation";

interface Props {
  setIsAuthenticated: (auth: boolean) => void;
}

const Login: React.FC<Props> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isEmpty(email) || isEmpty(password)) {
      toast.error("Enter email and password");
      return;
    }

    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);

      const res = await login({ email: email.trim(), password });

      const { details, accessToken, refreshToken } = res.data;

      // ✅ Store auth data
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      localStorage.setItem(
        "adminDetail",
        JSON.stringify({
          id: details.id,
          email: details.email,
          role: details.role.name,
          name: details.name,
        }),
      );

      if (res?.status === true) {
        toast.success("User logged in successfully");
      }

      setIsAuthenticated(true);
      navigate("/dashboard", { replace: true });
      dispatch(fetchAdminPermissions());
    } catch (error: any) {
      console.error("Login error:", error);
      toast.error(error?.response?.data?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left side with gradient & logo */}
      <div className="login-left">
        <img src={logo} alt="Logo" className="login-logo" />
      </div>

      {/* Right side with form */}
      <div className="login-right">
        <div className="login-right-header">
          <h1>VCU Admin Portal</h1>
          <p>
            {" "}
            Admins can log in and access the portal by entering their email ID
            and password.
          </p>
        </div>
        <form className="login-form" onSubmit={handleLogin}>
          <Input
            type="email"
            label="Email"
            placeholder="youremail@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            type="password"
            label="Password"
            value={password}
            placeholder="☆ ☆ ☆ ☆ ☆ ☆ ☆ ☆ ☆"
            onChange={(e) => setPassword(e.target.value)}
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword((prev) => !prev)}
            endIcon={showPassword ? <EyeOpenIcon /> : <EyeOffIcon />}
          />

          <div className="login-button">
            <Button
              text={loading ? "Signing in..." : "Sign in"}
              type="submit"
              // disabled={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
